<div class="trg-checkbox {{color ? 'trg-checkbox-color-' + color : ''}}"
     [class.unchecked]="viewIsUnchecked()"
     [class.checked]="viewIsChecked()"
     [class.indeterminate]="indeterminate"
     [class.trg-checkbox-large]="size === 'large'"
     [class.trg-checkbox-small]="size === 'small'"
     [class.trg-checkbox-tiny]="size === 'tiny'"
     [class.trg-checkbox-tabbed]="size === 'tabbed'"
     [class.trg-checkbox-no-text]="noText"
     [class.disabled]="disabled"
     [class.trg-checkbox-hide-border]="hideBorder"
     (click)="checkClicked()">
  <div *ngIf="!hideIcon" class="trg-checkbox__icon">
    <ng-container *ngIf="appearance === 'circle'">
      <i *ngIf="viewIsUnchecked()" class="far fa-circle"></i>
      <i *ngIf="viewIsChecked()" class="fas fa-check-circle"></i>
      <i *ngIf="indeterminate" class="fas fa-minus-circle"></i>
    </ng-container>
    <ng-container *ngIf="appearance === 'square'">
      <i *ngIf="viewIsUnchecked()" class="far fa-square"></i>
      <i *ngIf="viewIsChecked()" class="fas fa-check-square"></i>
      <i *ngIf="indeterminate" class="fas fa-minus-square"></i>
    </ng-container>
  </div>
  @if (!noText) {
    <div class="trg-checkbox__text text-ellipsis">
      <ng-content></ng-content>
    </div>
  }
</div> 
